var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigureViewNameDto, CreateOrUpdateViewDto, EntityDtoOfInt32, SetMainViewDto } from '../../../../shared/service-proxies/service-proxies';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { DiagramEx } from '../../diagram/diagram-ex';
import { ViewBackgroundFillType } from '../../../view-data/view/background/view-background-fill-type';
import { ViewPopupBackdropType } from '../../../view-data/view/pop-view/view-popup-backdrop-type';
import { ViewPopupLocationType } from '../../../view-data/view/pop-view/view-popup-location-type';
import { ConfigureViewSizeChangedArgs } from '../shared/configure-view-size-changed.args';
import { ConfigureViewType } from '../shared/configure-view-type';
import { DesignerConsts } from '../shared/designer-consts';
import { CopyConfigureViewModalComponent } from './copy-view-modal/copy-view-modal.component';
import { ViewSettingsModalComponent } from './view-setting/view-settings-modal.component';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
var ConfigureViewListComponent = /** @class */ (function (_super) {
    __extends(ConfigureViewListComponent, _super);
    function ConfigureViewListComponent(injector, configureViewService, bsModalService) {
        var _this = _super.call(this, injector) || this;
        _this.configureViewService = configureViewService;
        _this.bsModalService = bsModalService;
        _this.thumbnailView = new ConfigureViewNameDto();
        _this.configureViewType = {
            web: ConfigureViewType.Web,
            mobile: ConfigureViewType.Mobile,
            popView: ConfigureViewType.PopView
        };
        _this.selectedViewIdChange = new EventEmitter();
        _this.loadConfigureViewNamesCallBack = function () { return _this.loadConfigureViewNames(); };
        return _this;
    }
    Object.defineProperty(ConfigureViewListComponent.prototype, "selectedViewId", {
        get: function () {
            return this._selectedViewId;
        },
        set: function (value) {
            this._selectedViewId = value;
            this.selectedViewIdChange.emit(this._selectedViewId);
        },
        enumerable: true,
        configurable: true
    });
    ConfigureViewListComponent.prototype.ngOnInit = function () {
        this.loadConfigureViewNames();
        abp.event.on('designer:view-list:refresh', this.loadConfigureViewNamesCallBack);
    };
    ConfigureViewListComponent.prototype.ngOnDestroy = function () {
        abp.event.off('designer:view-list:refresh', this.loadConfigureViewNamesCallBack);
    };
    ConfigureViewListComponent.prototype.loadConfigureViewNames = function () {
        var _this = this;
        this.webViews = new Array();
        this.mobileViews = new Array();
        this.popViews = new Array();
        this.configureViewService.getConfigureViewsNames(this.configureId).subscribe(function (r) {
            _.forEach(r.items, function (view) {
                if (view.type === ConfigureViewType.Web) {
                    _this.webViews.push(view);
                    if (!_this.webMainViewId && view && view.isMainView) {
                        abp.event.trigger('designer:open-view', { view: view });
                        _this.updateWebMainViewId(view.id);
                    }
                }
                else if (view.type === ConfigureViewType.Mobile) {
                    _this.mobileViews.push(view);
                    if (view.isMainView) {
                        _this.updateMobileMainViewId(view.id);
                    }
                }
                else if (view.type === ConfigureViewType.PopView) {
                    _this.popViews.push(view);
                }
                else {
                    view.name = _this.lc('Thumbnail');
                    _this.thumbnailView = view;
                }
            });
        });
    };
    //#region more operations
    ConfigureViewListComponent.prototype.openView = function (view) {
        this.selectedViewId = view.id;
        abp.event.trigger('designer:open-view', { view: view });
    };
    ConfigureViewListComponent.prototype.deleteView = function (view) {
        var _this = this;
        // eslint-disable-next-line eqeqeq
        if (view.id == this.webMainViewId) {
            abp.message.info(this.lc('CanNotDeleteMainView'));
            return;
        }
        // eslint-disable-next-line eqeqeq
        var message = view.id == this.mobileMainViewId ?
            this.lc('DeleteMobileMainViewWarning') : this.lc('SureToDelete') + " " + view.name;
        this.message.confirm(message, "" + this.lc('Delete') + this.lc('View'), function (isConfirmed) {
            if (!isConfirmed) {
                return;
            }
            abp.ui.setBusy();
            setTimeout(function () {
                _this.configureViewService.deleteConfigureView(view.id).pipe(finalize(function () { return abp.ui.clearBusy(); }))
                    .subscribe(function () {
                    _this.loadConfigureViewNames();
                    abp.event.trigger('designer:delete-view', view);
                });
            }, 100);
        });
    };
    ConfigureViewListComponent.prototype.copyView = function (view) {
        var _this = this;
        var args = {
            configureId: this.configureId,
            configureView: _.cloneDeep(view),
        };
        var modalRef = this.bsModalService.show(CopyConfigureViewModalComponent, {
            initialState: { args: args },
            backdrop: 'static', class: 'copy-configure-view-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            onClosedSub.unsubscribe();
            if (result) {
                abp.ui.setBusy();
                _this.configureViewService.copyConfigureView(result).pipe(finalize(function () { return abp.ui.clearBusy(); }))
                    .subscribe(function () {
                    _this.notify.info(_this.l('SuccessfullySaved'));
                    _this.loadConfigureViewNames();
                });
            }
        });
    };
    ConfigureViewListComponent.prototype.setViewSettings = function (view) {
        this.selectedViewId = view.id;
        abp.event.trigger('designer:open-view', { view: view, isShowSettings: true });
    };
    ConfigureViewListComponent.prototype.showOrHideMoreSet = function (event) {
        event.stopPropagation();
        var currentTarget = $(event.currentTarget);
        if (this._currentMoreOperationId) {
            $('#' + this._currentMoreOperationId).children('.screen-more').hide(300);
        }
        var isShowMode = !currentTarget.children('.screen-more').is(':hidden');
        if (!isShowMode) {
            currentTarget.children('.screen-more').show(300);
            this._currentMoreOperationId = currentTarget.attr('id');
        }
        else {
            currentTarget.children('.screen-more').hide(300);
            this._currentMoreOperationId = undefined;
        }
    };
    //#endregion
    //#region Web Views
    ConfigureViewListComponent.prototype.setWebMainView = function (view) {
        var _this = this;
        var input = new SetMainViewDto({ configureId: this.configureId, viewId: view.id });
        this.configureViewService.setWebMainView(input).subscribe(function () {
            _this.updateWebMainViewId(view.id);
            _this.notify.info(_this.lc('SuccessfullySetted'));
        });
    };
    ConfigureViewListComponent.prototype.updateWebMainViewId = function (viewId) {
        this.webMainViewId = viewId;
        abp.event.trigger('designer:update-webMainViewId', viewId);
    };
    //#endregion
    //#region Mobile Views
    ConfigureViewListComponent.prototype.setMobileMainView = function (view) {
        var _this = this;
        var input = new SetMainViewDto({ configureId: this.configureId, viewId: view.id });
        this.configureViewService.setMobileMainView(input).subscribe(function () {
            _this.updateMobileMainViewId(view.id);
            _this.notify.info(_this.lc('SuccessfullySetted'));
        });
    };
    ConfigureViewListComponent.prototype.resetMobileMainView = function () {
        var _this = this;
        this.message.confirm(this.lc('ResetMobileMainViewWarning'), this.lc('ResetMobileMainView'), function (isConfirmed) {
            if (!isConfirmed) {
                return;
            }
            setTimeout(function () {
                var input = new EntityDtoOfInt32({ id: _this.configureId });
                _this.configureViewService.resetMobileMainView(input).subscribe(function () {
                    _this.updateMobileMainViewId(0);
                    _this.notify.info(_this.lc('SuccessfullySetted'));
                });
            }, 100);
        });
    };
    ConfigureViewListComponent.prototype.updateMobileMainViewId = function (viewId) {
        this.mobileMainViewId = viewId;
        abp.event.trigger('designer:update-mobileMainViewId', viewId);
    };
    //#endregion
    //#region  viewSetting
    ConfigureViewListComponent.prototype.createView = function (viewType) {
        return __awaiter(this, void 0, void 0, function () {
            var args, defaultSize, generalSetting, modalRef, onClosedSub;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        args = {
                            configureId: this.configureId,
                            viewId: undefined,
                            data: {
                                general: {
                                    viewType: viewType,
                                    name: undefined,
                                    height: 300,
                                    width: 400
                                }, background: undefined
                            }
                        };
                        generalSetting = args.data.general;
                        if (!(viewType === ConfigureViewType.PopView)) return [3 /*break*/, 1];
                        generalSetting.popViewSetting = {
                            locationType: ViewPopupLocationType.Center,
                            backdropType: ViewPopupBackdropType.Shadow
                        };
                        return [3 /*break*/, 3];
                    case 1:
                        abp.ui.setBusy();
                        return [4 /*yield*/, this.configureViewService.getConfigureViewSetting(this.configureId, viewType.valueOf()).toPromise()];
                    case 2:
                        defaultSize = _a.sent();
                        generalSetting.height = defaultSize.defaultHeight;
                        generalSetting.width = defaultSize.defaultWidth;
                        abp.ui.clearBusy();
                        _a.label = 3;
                    case 3:
                        args.data.background = { fillType: ViewBackgroundFillType.SolidColor, solidColor: 'white' };
                        modalRef = this.bsModalService.show(ViewSettingsModalComponent, {
                            initialState: { args: args },
                            backdrop: 'static', class: 'configure-view-setting-modal'
                        });
                        onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
                            if (!result) {
                                modalRef.hide();
                                onClosedSub.unsubscribe();
                                return;
                            }
                            _this.saveViewSettings(result, defaultSize).then(function (r) {
                                if (r) {
                                    onClosedSub.unsubscribe();
                                    modalRef.hide();
                                }
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigureViewListComponent.prototype.saveViewSettings = function (result, viewSetting) {
        var emptyDiagramModel = this.saveDiagramSetting(result);
        return this.saveConfigureViewProperties(result, viewSetting, emptyDiagramModel);
    };
    ConfigureViewListComponent.prototype.saveDiagramSetting = function (result) {
        var generalSetting = result.general;
        var viewSettingGoModel = {
            background: result.background
        };
        if (generalSetting.viewType === ConfigureViewType.PopView) {
            viewSettingGoModel.popup = result.general.popViewSetting;
        }
        var goModel = DiagramEx.createEmptyDiagramModel();
        goModel.setViewSettings(viewSettingGoModel);
        return goModel;
    };
    ConfigureViewListComponent.prototype.saveConfigureViewProperties = function (result, viewSetting, emptyDiagramModel) {
        var _this = this;
        var generalSetting = result.general;
        var popViewSaveDto = new CreateOrUpdateViewDto();
        popViewSaveDto.configure = JSON.stringify(emptyDiagramModel.model);
        popViewSaveDto.configureId = this.configureId;
        popViewSaveDto.viewType = generalSetting.viewType.valueOf();
        popViewSaveDto.height = generalSetting.height;
        popViewSaveDto.width = generalSetting.width;
        popViewSaveDto.name = generalSetting.name;
        abp.ui.setBusy();
        return new Promise(function (resolve, reject) {
            _this.configureViewService.createOrUpdateView(popViewSaveDto).pipe(finalize(function () { return abp.ui.clearBusy(); }))
                .subscribe(function () {
                _this.loadConfigureViewNames();
                var viewSizeModified = viewSetting &&
                    (generalSetting.height !== viewSetting.defaultHeight || generalSetting.width !== viewSetting.defaultWidth);
                if (viewSizeModified) {
                    var args = new ConfigureViewSizeChangedArgs(generalSetting.viewType, generalSetting.height, generalSetting.width);
                    abp.event.trigger(DesignerConsts.events.viewSizeChanged, args);
                }
                resolve(true);
                abp.notify.success(_this.l('OperationSuccessfully'));
            }, function (err) {
                resolve(false);
            });
        });
    };
    //#endregion
    ConfigureViewListComponent.prototype.getIconClass = function (view) {
        if (view.type === ConfigureViewType.Web) {
            return view.id === this.webMainViewId ? 'screen-startup-web-icon' : 'screen-default-web-icon';
        }
        else if (view.type === ConfigureViewType.Mobile) {
            return view.id === this.mobileMainViewId ? 'screen-startup-app-icon' : 'screen-default-app-icon';
        }
        else if (view.type === ConfigureViewType.Thumbnail) {
            return 'screen-thumbnail-icon';
        }
        else if (view.type === ConfigureViewType.PopView.valueOf()) {
            return 'popview-thumbnail-icon';
        }
    };
    __decorate([
        Input()
    ], ConfigureViewListComponent.prototype, "configureId", void 0);
    __decorate([
        Input()
    ], ConfigureViewListComponent.prototype, "selectedViewId", null);
    __decorate([
        Output()
    ], ConfigureViewListComponent.prototype, "selectedViewIdChange", void 0);
    ConfigureViewListComponent = __decorate([
        Component({
            selector: 'configure-view-list',
            template: "<div class=\"design-view-list\"> <div class=\"screen\"> <div class=\"configTitle\"> <span>{{lc('View')}}</span> </div> <div class=\"screenBody\"> <div class=\"view-expander\"> <a class=\"expander-button\" (click)=\"createView(configureViewType.web)\"> <i class=\"fcloud-addCity\"></i> </a> <div data-toggle=\"collapse\" href=\"#web-views\" role=\"button\" aria-controls=\"web-views\"> <i class=\"fa expander-icon\"></i> <span class=\"screen-name\">{{lc('Web')}}</span> </div> </div> <div id=\"web-views\" class=\"collapse show\"> <div *ngFor=\"let view of webViews\" class=\"screen-items\" [class.selected]=\"view.id==selectedViewId\" (click)=\"openView(view)\"> <i class=\"screen-icon\" [ngClass]=\"getIconClass(view)\"></i> <span class=\"screen-name\">{{view.name}}</span> <span class=\"more\" [id]=\"'operation_'+view.id\"  (click)=\"showOrHideMoreSet($event)\" > <i class=\"screen-icon more-icon\"></i> <div class=\"screen-more\" > <nav> <a (click)=\"setViewSettings(view)\">{{l('Modify')}}</a> <a (click)=\"copyView(view)\">{{lc('Copy')}}</a> <a (click)=\"setWebMainView(view)\" *ngIf=\"view.id!=webMainViewId\">{{lc('SetAsWebMainView')}}</a> <a (click)=\"deleteView(view)\">{{lc('Delete')}}</a> </nav> </div> </span> </div> </div> <div class=\"view-expander\"> <a class=\"expander-button\" (click)=\"createView(configureViewType.mobile)\"> <i class=\"fcloud-addCity\"></i> </a> <div data-toggle=\"collapse\" href=\"#mobile-views\" role=\"button\" aria-controls=\"mobile-views\"> <i class=\"fa expander-icon\"></i> <span class=\"screen-name\">{{lc('Mobile')}}</span> </div> </div> <div id=\"mobile-views\" class=\"collapse show\"> <div *ngFor=\"let view of mobileViews\" class=\"screen-items\" [class.selected]=\"view.id==selectedViewId \" (click)=\"openView(view)\"> <i class=\"screen-icon\" [ngClass]=\"getIconClass(view)\"></i> <span class=\"screen-name\"> <em>{{view.name}}</em> </span> <span class=\"more\" [id]=\"'operation_'+view.id\"  (click)=\"showOrHideMoreSet($event)\"> <i class=\"screen-icon more-icon \"></i> <div class=\"screen-more\" > <nav> <a (click)=\"setViewSettings(view)\">{{l('Modify')}}</a> <a (click)=\"copyView(view)\">{{lc('Copy')}}</a> <a (click)=\"setMobileMainView(view)\" *ngIf=\"view.id!=mobileMainViewId\">{{lc('SetAsMobileMainView')}}</a> <a (click)=\"resetMobileMainView()\" *ngIf=\"view.id==mobileMainViewId\">{{lc('ResetMobileMainView')}}</a> <a (click)=\"deleteView(view)\">{{lc('Delete')}}</a> </nav> </div> </span> </div> </div> <div class=\"view-expander\"> <a class=\"expander-button\" (click)=\"createView(configureViewType.popView)\"> <i class=\"fcloud-addCity\"></i> </a> <div data-toggle=\"collapse\" href=\"#pop-window-views\" role=\"button\" aria-controls=\"pop-window-views\"> <i class=\"fa expander-icon\"></i> <span class=\"screen-name\">{{lc('PopView')}}</span> </div> </div> <div id=\"pop-window-views\" class=\"collapse show\"> <div *ngFor=\"let view of popViews\" class=\"screen-items\" [class.selected]=\"view.id==selectedViewId\" (click)=\"openView(view)\"> <i class=\"screen-icon\" [ngClass]=\"getIconClass(view)\"></i> <span class=\"screen-name\"> <em>{{view.name}}</em> </span> <span class=\"more\" [id]=\"'operation_'+view.id\" (click)=\"showOrHideMoreSet($event)\"> <i class=\"screen-icon more-icon \"></i> <div class=\"screen-more\"> <nav> <a (click)=\"setViewSettings(view)\">{{l('Modify')}}</a> <a (click)=\"copyView(view)\">{{lc('Copy')}}</a> <a (click)=\"deleteView(view)\">{{lc('Delete')}}</a> </nav> </div> </span> </div> </div> <div class=\"screen-items\" [class.selected]=\"selectedViewId==thumbnailView.id\" (click)=\"openView(thumbnailView)\"> <i class=\"screen-icon\" class=\"screen-icon screen-thumbnail-icon\"></i> <span class=\"screen-name\">{{lc(\"Thumbnail\")}}</span> <span class=\"more\" [id]=\"'operation_'+thumbnailView.id\" (click)=\"showOrHideMoreSet($event)\"> <i class=\"screen-icon more-icon \"></i> <div class=\"screen-more\"> <nav> <a (click)=\"setViewSettings(thumbnailView)\">{{lc('SetViewSettings_Menu')}}</a> </nav> </div> </span> </div> </div> </div> </div>",
            styles: [".design-view-list{ .screen { width: 220px; .screenBody { background: #fff; -webkit-tap-highlight-color: #ffffff; height: 260px; overflow: auto; padding: 2px 8px; .view-expander { height: 24px; cursor: pointer; i { padding: 0 6px 0 0; color: #999; } .expander-icon:before { content: \"\\f0d7\"; } .expander-button { width: 24px; height: 24px; float: right; .fcloud-view-setting { color: #7f939f; padding: 0; vertical-align: middle; margin-left: 5px; } .fcloud-addCity { color: #7f939f; padding: 0; vertical-align: middle; margin-left: 5px; } } .expander-button:hover { .fcloud-view-setting { color: #3695ff; } .fcloud-addCity { color: #3695ff; } } .collapsed { i { padding: 0 6px 0 3px; } .expander-icon:before { content: \"\\f0da\"; } } } .screen-items { height: 24px; line-height: 24px; border-radius: 2px; position: relative; cursor: pointer; display: flex; justify-content: space-between; align-items: center; .screen-icon { display: inline-block; vertical-align: middle; margin: 0 6px 0 16px; height: 14px; width: 14px; background-image: url(\"/assets/common/images/configure/toolbar.png\"); } .screen-default-web-icon { background-position: -94px -160px; } .screen-default-app-icon { background-position: -122px -160px; } .screen-startup-web-icon { background-position: -80px -160px; } .screen-startup-app-icon { background-position: -108px -160px; } .screen-thumbnail-icon { background-position: -136px -160px; } .screen-name { font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; em { font-style: normal; } } .title { background-position: -128px -160px; } .more { float: right; width: 24px; .more-icon { background-position: -60px -166px; margin: 0 0 0 4px; } } .screen-more { box-shadow: 0 0 5px #666; position: absolute; right: 2px; display: none; z-index: 20; background-color: #fff; width: 140px; nav { a { width: 100%; text-decoration: none; display: inline-block; font-size: 12px; padding: 2px 5px; color: #666; } a:hover { background-color: #dae8ff; } } } } .screen-items.selected { .title { background-position: -139px -160px; } } .screen-items.selected:hover { background-color: #3695ff; color: #fff; .more:hover { background-color: #2783ea } } .screen-items:hover { background-color: #dae8ff; color: #333; .more:hover { background-color: #c1d8fe; } } .popview-thumbnail-icon{ background-position: -80px -174px; } } } } "]
        })
    ], ConfigureViewListComponent);
    return ConfigureViewListComponent;
}(ConfigureComponentBase));
export { ConfigureViewListComponent };
